import styled from "styled-components";
import colors from "../../../../styles/colors";
import { Input } from "../../CourseAuthor/FormElements";
import { CustomSearchInputContainer } from "../../../../App/Common/Components/FormComponents";

export const UsersTableContainer = styled.div`
  width: 100%;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 2rem 0;
`;

export const HeadingLine = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem 0;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  font-size: 1.2rem;
  background: ${({ theme }) => theme.colors.lightgrey3};
  border-radius: 8px;
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0;
  div {
    margin: 0 2rem 0 0;
  }
`;

export const SearchInputContainer = styled(CustomSearchInputContainer as any)`
  background-color: ${({ theme }) => theme.colors.lightgrey3};
  margin-right: 1rem;
  padding: unset;
`;

export const SearchInput = styled(Input as any)`
  border: none;
  background: none;
  font-size: ${({ theme }) => theme.fontSizes.small};
  margin: 0 1rem;
  padding: 0.5rem;

  ::placeholder {
    color: ${({ theme }) => theme.colors.lightgrey4};
    font-style: italic;
  }
`;

export const CustomCheckBox = styled.input`
  accent-color: ${colors.blue};
`;
